module.exports = __webpack_public_path__ + "media/images/featured_events-17ce432cfe4d10318e021abf2ae529d5.jpeg";